import React, { Component } from 'react';
import { withRouter, Link } from 'react-router'

class NavLink extends Component {
    render() {

		    let isActive = this.props.router.isActive(this.props.to, true)			    
		    let activeClassName = isActive ? "active" : "";

        return (
            <li className={activeClassName}>
                <Link to={this.props.to}>
									{this.props.children}
               	</Link>
            </li>
        );
    }
}

export default withRouter(NavLink);


// WEBPACK FOOTER //
// ./src/components/NavLink.js